// extracted by mini-css-extract-plugin
export default {"moreActionEllipsis":"MoreActionEllipsis_moreActionEllipsis__8+yx1"};